import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductDetails() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        {/* Presentation */}
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-black mb-6 uppercase" data-id="element-126">
            MÁS DE 300 REMEDIOS NATURALES DE LA ABUELA
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-3xl mx-auto" data-id="element-127">
            Una guía práctica y organizada para volver a usar soluciones
            naturales simples, accesibles y efectivas para el día a día.
          </p>
        </div>

        {/* What's inside */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 md:p-12 mb-16" data-id="element-128">
          <h3 className="text-2xl font-bold text-center mb-8 uppercase tracking-wide" data-id="element-129">
            ¿QUÉ ENCONTRARÁS DENTRO?
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-130">
            {['Más de 300 remedios naturales paso a paso', 'Soluciones organizadas por síntoma', 'Infusiones, hierbas y preparaciones tradicionales', 'Explicaciones fáciles de entender', 'Recetas naturales con ingredientes comunes', 'Guías prácticas para distintas situaciones cotidianas'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-131">
                <Check className="w-6 h-6 text-brand-green flex-shrink-0 mt-1" data-id="element-132" />
                <span className="text-lg font-medium text-gray-800" data-id="element-133">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Benefits */}
        <div className="mb-16" data-id="element-134">
          <h3 className="text-3xl font-heading font-black text-center mb-10 uppercase" data-id="element-135">
            ¿Qué vas a aprender?
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-136">
            {['Crear más de 300 remedios naturales paso a paso', 'Cuidar tu salud y la de tu familia con más tranquilidad', 'Tener soluciones naturales organizadas para el día a día', 'Dormir con la tranquilidad de no depender constantemente de químicos', 'Recuperar conocimientos naturales simples y útiles', 'Ahorrar tiempo buscando soluciones mezcladas en internet', 'Tener una biblioteca natural completa en tu celular', 'Aprender cuándo usar remedios naturales y cuándo consultar profesionalmente'].map((item, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-137">
                <span className="text-2xl flex-shrink-0" data-id="element-138">🌿</span>
                <span className="text-lg font-medium text-gray-800" data-id="element-139">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Categories */}
        <div className="bg-black text-white rounded-2xl p-8 md:p-12 mb-16" data-id="element-140">
          <h3 className="text-2xl font-bold text-center mb-8" data-id="element-141">
            Con esta guía aprenderás remedios naturales para:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-142">
            {['Inflamación y dolores', 'Ansiedad y sueño', 'Resfriados y defensas', 'Digestión', 'Dolores musculares', 'Dolor articular y huesos', 'Estrés y cansancio', 'Piel y circulación', 'Bienestar general'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-143">
                <Check className="w-5 h-5 text-brand-yellow flex-shrink-0" data-id="element-144" />
                <span className="font-medium" data-id="element-145">{item}</span>
              </div>)}
          </div>
        </div>

        {/* Value Block */}
        <div className="text-center mb-12" data-id="element-146">
          <h3 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-147">
            Todo organizado para encontrar rápidamente lo que necesitás
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-xl font-bold text-gray-800 bg-white p-8 rounded-xl shadow-md border border-gray-200" data-id="element-148">
            <div className="flex flex-col items-center" data-id="element-149">
              <span className="text-3xl mb-2" data-id="element-150">🤕</span>
              <span data-id="element-151">"Me duele esto"</span>
              <span className="text-sm text-gray-500 font-normal" data-id="element-152">
                buscás el síntoma
              </span>
            </div>
            <ArrowRight className="w-8 h-8 text-brand-green hidden md:block" data-id="element-153" />
            <div className="flex flex-col items-center" data-id="element-154">
              <span className="text-3xl mb-2" data-id="element-155">📖</span>
              <span data-id="element-156">Encontrás el remedio</span>
            </div>
            <ArrowRight className="w-8 h-8 text-brand-green hidden md:block" data-id="element-157" />
            <div className="flex flex-col items-center" data-id="element-158">
              <span className="text-3xl mb-2" data-id="element-159">🥣</span>
              <span data-id="element-160">Ves cómo prepararlo</span>
              <span className="text-sm text-gray-500 font-normal" data-id="element-161">
                paso a paso
              </span>
            </div>
          </div>

          <p className="text-3xl font-heading font-black mt-8 text-brand-green uppercase" data-id="element-162">
            Simple. Práctico. Rápido.
          </p>
        </div>

        <CTAButton className="mt-8" data-id="element-163" />
      </div>
    </section>;
}